
// this file is loaded from the reschedule liquid

const base_url = window.TVSMOTOR_CONFIG?.base_url || ''; 
function getURLParameter(name) {
  const params = new URLSearchParams(window.location.search);
  return params.get(name);
}

function getCookie(name) {
    var n = name + "=";
    var dc = decodeURIComponent(document.cookie);
    var ca = dc.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(n) === 0) return c.substring(n.length, c.length);
    }
    return "";
}
function fetchAppointmentById(payload) {
  return $.ajax({
    url: base_url + "/fetchappointmentId",
    method: "POST",
    dataType: "json",
    contentType: "application/json",
    data: JSON.stringify(payload)
  });
}



	// Fetch  Mobile number from encrypted token
	async function hydrateMobileFromToken(mobileToken) {
		if (!mobileToken) return null;

		try {
			const response = await fetch(base_url + `/getmobilenumber?token=${mobileToken}`);
			const data = await response.json();

			const mob = data?.mobile
				? String(data.mobile).trim()
				: "";

			if (/^\d{10}$/.test(mob)) {
				$("#customer_contact").val(mob);
				// console.info("Mobile number hydrated from token:", mob);
				return mob;
			}

			return null;

		} catch (error) {
			$(".error-card").show();
			$(".reschedule_block").hide();
			$("#error-text").text("Token API failed");
			return null;
		}
	}

	$(async function () {
		$("#loaderr").css("display", "flex");
		const mobileToken = getURLParameter("token");	
		const channel = getURLParameter("channel");
		const frameNo = getURLParameter("frameNo");
		const appointmentId = getURLParameter("appointment_id");

		// Hide header/footer ONLY for encrypted-token deep link URLs
		if (mobileToken) {
			$("header, footer, .shopify-section-header-sticky, .shopify-section-footer, .announcement-bar-section").hide();
		}

		// mandatory parameters must be present
		if (!channel || !frameNo || !appointmentId) {
			$("#loaderr").css("display", "none");
			
			$("#error-text").text("Invalid request – missing channel, frameNo or appointment id");
			$(".error-card").show();
			$(".reschedule_block").hide();
			
			return;
		}

		// Wait for hydration
		const hydratedMobile = await hydrateMobileFromToken(mobileToken);
		const mobileNumber = hydratedMobile || $("#customer_contact").val() || "";
		if (mobileNumber) {
			const payload = {
				frameNo: frameNo || "",
				mobileNumber: mobileNumber,
				id: Number(appointmentId)
			};

			fetchAppointmentById(payload)
				.done(function (resp) {
					// console.log("fetchappointmentId success:", resp);

					if (!resp?.success || !resp?.data) {
						$("#error-text").text(resp?.message || "Failed to fetch appointment details");
						// toastr.error("", resp?.message || "Failed to fetch appointment details");
						$(".error-card").show();
						$(".reschedule_block").hide();
						return;
					}
					const data = resp.data;
					$("#loaderr").css("display", "none");
					// Extract values safely
					const appointmentId = data.appointment?.id || "";
					const dealerId = data.dealer?.id || "";
					const dealerName = data.dealer?.name || "";
					const branchId = data.dealer?.branch?.id || "";
					const branchName = data.dealer?.branch?.name || "";
					const customerId = data.customer?.id || "";
					const customerName = (data.customer?.name || "").trim();
					const channel = data.appointment?.communicationChannel || "";
					// Update hidden fields with fetched values
					$("#appoinment_id").val(appointmentId);
					$("#res_new_dealer_id").val(dealerId);
					$("#res_dealer_name").val(dealerName);
					$("#res_branch_id").val(branchId);
					$("#res_dealer_branch_name").val(branchName);
					$("#res_customer_id").val(customerId);
					$("#res_customer_name").val(customerName);
					$("#res_channel").val(channel);

				})
				.fail(function (xhr) {

				$("#loaderr").css("display", "none");
				// console.error("fetchappointmentId error:", xhr.responseJSON || xhr.statusText || xhr);
				// toastr.error("", "Failed to fetch appointment details");
				$("#error-text").text("Failed to fetch appointment details");
				$(".error-card").show();
				$(".reschedule_block").hide();
				});
			} else {
				$(".reschedule_block").hide();
				$(".error-card").show();
				$("#loaderr").css("display", "none");
				$("#error-text").text("Mobile number not available. API not called.");
				// toastr.error("", "Mobile number not available. API not called.");
				// console.warn("Mobile number not available. API not called.");
		}	
	});

	function _pad2(n){ return String(n).padStart(2,"0"); }
	function _isoDateOnly(d){ return `${d.getFullYear()}-${_pad2(d.getMonth()+1)}-${_pad2(d.getDate())}`; }

	function _parseDateRangeInput(val) {
		const v = String(val||"").trim();
		if (!v) return null;
		const parts = v.split(" to ");
		if (parts.length===1) parts.push(parts[0]);
		if (parts.length!==2) return null;
		function parseOne(s){
			const str = String(s||"").trim();
			const m = str.match(/^(\d{4})-(\d{2})-(\d{2})$/);
			if (m) return new Date(+m[1],+m[2]-1,+m[3]);
			const d = new Date(str);
			return isNaN(d.getTime())?null:d;
		}
		let from = parseOne(parts[0]);
		let to   = parseOne(parts[1]);
		if (!from||!to) return null;
		if (from.getTime()>to.getTime()){ const t=from;from=to;to=t; }
		return {from,to};
	}

	function _eachDay(from,to){
		const out=[]; for(let d=new Date(from);d<=to;d.setDate(d.getDate()+1)){ out.push(new Date(d)); }
		return out;
	}

	function _tabLabel(d){ return d.toLocaleDateString("en-US",{weekday:"long",month:"short",day:"numeric"}); }
	function _bookingLabel(d){ return d.toLocaleDateString("en-US",{month:"short",day:"numeric"}); }
	function _headerLabel(d){
		const day=d.toLocaleDateString("en-US",{day:"2-digit"});
		const mon=d.toLocaleDateString("en-US",{month:"short"});
		return `${parseInt(day,10)} ${mon} Available Slot`;
	}

	function _timeRangeToValue(timeRange){
		if(!timeRange) return "";
		const start=String(timeRange).split("-")[0].trim();
		const m=start.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
		if(!m) return "";
		let hh=parseInt(m[1],10), mm=parseInt(m[2],10), ap=m[3].toUpperCase();
		if(ap==="PM"&&hh!==12) hh+=12;
		if(ap==="AM"&&hh===12) hh=0;
		return `${_pad2(hh)}${_pad2(mm)}`;
	}

	function _normalizeDailyFromResp(resp){
		const daily=resp?.data?.dailySlotResponse
				|| resp?.data?.[0]?.dailySlotResponse
				|| resp?.dailySlotResponse
				|| (Array.isArray(resp?.data)?resp.data:null);
		if(!Array.isArray(daily)) return [];
		return daily.map(d=>{
			const dateObj=new Date(d.date);
			const dateKey=isNaN(dateObj.getTime())?"":_isoDateOnly(dateObj);
			return { dateKey, dateObj, isSlotAvailable: !!d.isSlotAvailable, slots: Array.isArray(d.slots)?d.slots:[] };
		}).filter(x=>x.dateKey);
	}

	function fetchSlotsByRange(fromDateStr,toDateStr){
		const token=getCookie("jwt_token");
		const dealerId = parseInt($("#res_new_dealer_id").val());
		const branchId = parseInt($("#res_branch_id").val() || 1);
		const payload={ dealerId, branchId, fromDate: fromDateStr, toDate: toDateStr };
		return $.ajax({
			url: base_url + "/fetch-slot",
			method: "POST",
			headers: { Authorization: "Bearer " + (token||"") },
			dataType: "json",
			contentType: "application/json",
			data: JSON.stringify(payload)
		});
	}

	function _disableAllSlots(){
		$(".slots").addClass("disabled time-btn-slot-disable").prop("disabled",true);
		$(".time_slot_js").removeClass("active");
	}

	function _resetSlotsPopupUI(){
		$("#dates_container").html("");
		$("#slot_id").val("");
		window._slotDailyMap = {};
		window._selectedSlotDateParts = null;
		_disableAllSlots();
	}

	function _applySlotsForDateKey(dateKey){
		const map = window._slotDailyMap||{};
		const day = map[String(dateKey||"")];
		const d = day?.dateObj? day.dateObj : new Date(String(dateKey)+"T00:00:00");
		$("#date_modal_selected").text(_headerLabel(d));
		$("#booking_date").val(_bookingLabel(d));
		window._selectedSlotDateParts={ y:d.getFullYear(), m:d.getMonth()+1, d:d.getDate() };
		_disableAllSlots();
		if(!day||day.isSlotAvailable!==true) return;
		(day.slots||[]).forEach(slot=>{
			const available=parseInt(slot.available,10);
			if(isNaN(available)||available<=0) return;
			const val=_timeRangeToValue(slot.time);
			if(!val) return;
			$(".slots."+val).removeClass("disabled time-btn-slot-disable").prop("disabled",false);
		});
		const now=new Date();
		if(_isoDateOnly(now)===String(dateKey)){
			const currentTime=parseInt(getCurrentTime(),10);
			$(".slots").each(function(){
				const v=parseInt($(this).find(".time_slot_js").attr("value"),10);
				if(!isNaN(v)&&v<currentTime){
					$(this).addClass("disabled time-btn-slot-disable").prop("disabled",true);
				}
			});
		}
	}

	function _buildRangeTabs(from,to,dailyList){
		const days=_eachDay(from,to);
		const dailyMap={};
		(dailyList||[]).forEach(d=>{ dailyMap[d.dateKey]=d; });
		window._slotDailyMap=dailyMap;
		const $container=$("#dates_container");
		$container.html("");
		days.forEach(d=>{
			const key=_isoDateOnly(d);
			const daily=dailyMap[key];
			const maxAvail = daily && daily.isSlotAvailable
				? (daily.slots||[]).reduce((mx,s)=>{ const a=parseInt(s.available,10); return isNaN(a)?mx:Math.max(mx,a); },0)
				: 0;
			const label=_tabLabel(d);
			$container.append(`
				<div class="date_slot" data-date-key="${key}" data-date="${label}">
					<h3 class="date">${label}</h3>
				</div>
			`);
		});
		const firstKey=days.length?_isoDateOnly(days[0]):"";
		if(firstKey){
			$container.find(`.date_slot[data-date-key="${firstKey}"]`).addClass("active");
			_applySlotsForDateKey(firstKey);
		}
	}

	function loadSlotsPopupFromSelectedRange(){
		window._slotRangeReqSeq=(window._slotRangeReqSeq||0)+1;
		const reqSeq=window._slotRangeReqSeq;
		try{ if(window._slotRangeXhr&&window._slotRangeXhr.readyState!==4) window._slotRangeXhr.abort(); }catch(_){}
		_resetSlotsPopupUI();
		const parsed=_parseDateRangeInput($("#dateRange").val());
		if(!parsed){ toastr.error("","Please select a date range"); return; }
		const today=new Date();
		const todayStart=new Date(today.getFullYear(),today.getMonth(),today.getDate());
		const fromStart=new Date(parsed.from.getFullYear(),parsed.from.getMonth(),parsed.from.getDate());
		const fromDateStr=_isoDateOnly(fromStart>todayStart?todayStart:fromStart);
		const toDateStr=_isoDateOnly(new Date(parsed.to.getFullYear(),parsed.to.getMonth(),parsed.to.getDate()));
		const p=fetchSlotsByRange(fromDateStr,toDateStr);
		window._slotRangeXhr=p;
		p.then(resp=>{
			if(reqSeq!==window._slotRangeReqSeq) return;
			const hasDaily=!!(resp?.dailySlotResponse||resp?.data?.dailySlotResponse||resp?.data?.[0]?.dailySlotResponse);
			if(!resp||(resp.success!==true&& !hasDaily)) throw new Error(resp?.message||"Unable to fetch slots");
			const dailyList=_normalizeDailyFromResp(resp);
			_buildRangeTabs(parsed.from,parsed.to,dailyList);
			const sameDay=_isoDateOnly(new Date(parsed.from))===_isoDateOnly(new Date(parsed.to));
			if(sameDay){ $("#date_time_modal").show(); $("body").addClass("overflow-hidden"); }
		}).catch(err=>{
			if(reqSeq!==window._slotRangeReqSeq) return;
			_resetSlotsPopupUI();
			toastr.error("",(err&&err.message)?err.message:"Unable to fetch slots");
		});
	}

	// listen for range change
	$(document).on("change","#dateRange",loadSlotsPopupFromSelectedRange);

	// slot click handler from book‑a‑service.js (if needed on reschedule page)
	$(document).on("click","#date_time_modal .slots",function(e){
		if(e&&e.preventDefault){ e.preventDefault(); e.stopPropagation(); }
		if($(this).hasClass("time-btn-slot-disable")||$(this).hasClass("disabled")||$(this).prop("disabled")) return;
		const $p=$(this).find(".time_slot_js");
		const slot=String($p.attr("value")||"").trim();
		if(!slot) return;
		$("#slot_id").val(slot);
		$("#date_time_modal .time_slot_js").removeClass("active");
		$p.addClass("active");
		let y=window._selectedSlotDateParts?.y;
		let m=window._selectedSlotDateParts?.m;
		let d=window._selectedSlotDateParts?.d;
		if(!y||!m||!d){
			try{
				const key=String($("#dates_container .date_slot.active").data("date-key")||"").trim();
				const mm=key.match(/^(\d{4})-(\d{2})-(\d{2})$/);
				if(mm){ y=parseInt(mm[1],10); m=parseInt(mm[2],10); d=parseInt(mm[3],10); }
			}catch(_){}
		}
		if(!y||!m||!d) return;
		let hours=slot.substring(0,slot.length-2);
		let minutes=slot.substring(slot.length-2);
		hours=String(hours).padStart(2,"0");
		minutes=String(minutes).padStart(2,"0");
		const dd=String(d).padStart(2,"0");
		const mm2=String(m).padStart(2,"0");
		const formattedDate=`${dd}-${mm2}-${y}`;
		const formattedTime=`${hours}:${minutes}`;
		const formattedDateTime=`${formattedDate} & ${formattedTime}`;
		$("#date_form_id").val(formattedDateTime).trigger("input");
		try{
			$("#selected-formated-date").text(formattedDateTime);
			$("#appointment_date_summary").text(formattedDateTime);
		}catch(_){}
		$("#date_time_modal").hide();
		$("body").removeClass("overflow-hidden");
	});


	function parseAppointmentISO_updated() {
			const v = $("#date_form_id").val() || "";

			// console.log("Parsing appointment datetime from input:", v);
			if (!v.includes("&")) return null;

			try {
				const [datePart, timePartRaw] = v.split("&").map(s => s.trim());
				const [dd, mm, yyyy] = datePart.split("-");

				// Directly construct string (NO Date object)
				const formatted = `${yyyy}-${mm}-${dd}T${timePartRaw}:00.000Z`;

				return formatted;
			} catch (e) {
				// console.log("Date parse error:", e);
				return null;
			}
		}


	// Reload page on cancel button click
	// $("#reschedule-btn-cancel").on("click", function (e) {
	$(document).on("click", "#reschedule-btn-cancel", function (e) {

		e.preventDefault();
		e.stopPropagation();
		window.location.reload();
	});
	

	/* ---------------------------------------
	Reschedule Click Handler
	--------------------------------------- */
	// $("#reschedule-btn-action").on("click", async function (event) {

	$(document).on("click", "#reschedule-btn-action", async function (event) {
	event.preventDefault();
	event.stopPropagation();
	
	var selectedDateStr = $("#date_form_id").val();

	if (!selectedDateStr) {
		toastr.error("", "Please select service date & time");
		return;
	}
	var isoDateTime = parseAppointmentISO_updated(selectedDateStr);

	if (!isoDateTime) {
		toastr.error("", "Invalid date format");
		return;
	}
	if ($("#loaderr").length) {
		$("#loaderr").css("display", "flex");
	}

	
	// Extract appointment ID
	var appointmentId = $('#appoinment_id').val() || '';
	if (!appointmentId) {
		if (typeof toastr !== 'undefined' && toastr && toastr.error) {
		toastr.error('', 'Unable to reschedule appointment.');
		} else {
		alert('Unable to reschedule appointment.');
		}
		return;
	}

	// Get dynamic customer details
	var customerId = ($('#res_customer_id').val && $('#res_customer_id').val()) || '';
	var customerName = ($('#res_customer_name').val && $('#res_customer_name').val()) || '';
	var mobile = ($('#res_customer_contact').val && $('#res_customer_contact').val()) || '';

	// Get dynamic dealer details
	var dealerId = ($('#res_new_dealer_id').val && $('#res_new_dealer_id').val()) || '';
	var dealerName = ($('#res_dealer_name').val && $('#res_dealer_name').val()) || '';
	var branchId = 
		($('#res_branch_id').val && $('#res_branch_id').val())  || '1';
	var branchName =($('#res_branch_name').val && $('#res_branch_name').val()) || '';

	// Get communication channel (dynamic if available)
	var urlChanel = getURLParameter("chanel");
	var communicationChannel = urlChanel || "WEBSITE";
	var payload = {
		appointment: {
		dateTime: isoDateTime,
		status: "Open",
		communicationChannel: communicationChannel,
		Comments: "ONLINE APPOINTMENT",
		FollowupType: false,
		EmployeeId: 1
		},
		customer: {
		id: customerId ? parseInt(customerId, 10) || 0 : 0,
		name: customerName || '',
		contact: mobile ? [{ type: 1, number: String(mobile), isPrimary: true }] : []
		},
		dealer: {
		id: dealerId ? parseInt(dealerId, 10) || 0 : 0,
		name: dealerName || '',
		branch: {
			id: branchId ? parseInt(branchId, 10) || 0 : 1,
			name: branchName || 'Main branch'
		}
		}
	};

	 const token = getCookie("jwt_token"); 
	try {
		var url = base_url + '/appointment/' + encodeURIComponent(appointmentId) + '/update';

		var resp = await $.ajax({
		url: url,
		method: "PUT",
		// headers: {
		// 		Authorization: "Bearer " + (token || ""),
		// 	},
		contentType: "application/json",
		dataType: "json",
		data: JSON.stringify(payload),
		crossDomain: true,
		xhrFields: { withCredentials: true },
		timeout: 30000
		});

		var success =
		resp &&
		resp.success === true &&
		resp.data &&
		Number(resp.data.statusCode) === 200;

		if (success) {
		sessionStorage.setItem(
			"rescheduleData",
			JSON.stringify({
			appointmentId: appointmentId, 
			appointmentDateTime: selectedDateStr,
			channel:'TVS_CONNECT', 
			})
		);
		// window.location.replace("/pages/booking-updated");
		window.location.href =
			"https://service.tvsmotor.com/pages/booking-updated";

		} else {
		var msg =
			resp?.data?.message || "Failed to update appointment";
		toastr?.error("", msg);
		}

	} catch (err) {
		var msg2 =
		err?.responseJSON?.data?.message ||
		"Failed to update appointment";
		toastr?.error("", msg2) || alert(msg2);
	} finally {
		
		if ($("#loaderr").length) {
		$("#loaderr").css("display", "none");
		}
	}
	});